import React from "react";

import { getIcon } from "../../../utils/getIcon";

import type { Integration } from "../../types/integrations";

interface StepHeaderProps {
  integration: Integration;
  title?: string;
  className?: string;
}

export function StepHeader({
  integration,
  title,
  className = "flex items-center gap-4 mb-6",
}: StepHeaderProps) {
  const displayTitle = title || `Connect ${integration.value}`;

  return (
    <div className={className}>
      <div className="w-8 h-8 bg-neutral-50 dark:bg-neutral-700 rounded-md flex items-center justify-center overflow-hidden">
        <div className="flex items-center justify-center text-zinc-600 dark:text-zinc-300">
          {getIcon(integration.label)}
        </div>
      </div>
      <div className="flex-1">
        <h2 className="font-semibold text-base text-zinc-900 dark:text-white">
          {displayTitle}
        </h2>
      </div>
    </div>
  );
}
